import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';
import { APIClient } from "../helpers/api_helper";
import { useDispatch } from 'react-redux';
import { loadTags } from '../slices/thunk';


const api = new APIClient();


export const BUDGET_UNIT_OPTIONS = [
  {'value': 'pcs', 'label': 'kos'},
  {'value': 'day', 'label': 'dan'},
  {'value': 'week', 'label': 'teden'},
  {'value': 'month', 'label': 'mesec'},
  {'value': 'project', 'label': 'projekt'},
  {'value': 'episode', 'label': 'epizoda'},
];

// Unit is a free-form CharField on the backend, so fall back to the raw value
// for anything that isn't one of the known options.
export const budgetUnitLabel = value =>
  BUDGET_UNIT_OPTIONS.find(o => o.value === value)?.label ?? value;


const BudgetUnitSelect = ({ value = [], onChange, size = 'small' }) => {

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');

  return (
    <Select
      size={size}
      open={open}
      onDropdownVisibleChange={setOpen}
      style={{ minWidth: 200, flex: 1}}
      placeholder="Izberi enoto"
      optionFilterProp="label"
      value={value}
      onChange={onChange}
      options={BUDGET_UNIT_OPTIONS}
      allowClear
    />
  );
};

export default BudgetUnitSelect;
